import { FC, PropsWithChildren, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ConflictsNav, ExpandedAdornment } from "@ryde/controls";

import { GenericUploadColumnConflictsContext } from "../../contexts";

type IColumnConflictsExpandedProps = PropsWithChildren;

export const ColumnConflictsExpanded: FC<IColumnConflictsExpandedProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const { conflicts } = useContext(GenericUploadColumnConflictsContext);

  return (
    <ExpandedAdornment
      NavControl={
        <ConflictsNav
          title={t(`genericUpload.conflicts.${conflicts?.at(0)?.errorType}`)}
          conflictNumber={conflicts?.length ?? 0}
          severity={conflicts?.at(0)?.errorSeverity}
        />
      }
    >
      {children}
    </ExpandedAdornment>
  );
};
